import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide', 'dot']
  static values = {
    interval: { type: Number, default: 6000 },
    offset: { type: Number, default: 0 }
  }

  connect () {
    if (!this.slideTargets.length) return

    this.index = this.offsetValue % this.slideTargets.length
    this.showSlide(this.index)

    if (this.slideTargets.length > 1) {
      this.timer = window.setInterval(() => this.advance(), this.intervalValue)
      this.element.addEventListener('mouseenter', this.pause)
      this.element.addEventListener('mouseleave', this.resume)
    }
  }

  disconnect () {
    this.stopTimer()
    this.element.removeEventListener('mouseenter', this.pause)
    this.element.removeEventListener('mouseleave', this.resume)
  }

  pause = () => {
    this.stopTimer()
  }

  resume = () => {
    if (this.slideTargets.length < 2) return
    this.stopTimer()
    this.timer = window.setInterval(() => this.advance(), this.intervalValue)
  }

  prev () {
    this.goTo((this.index - 1 + this.slideTargets.length) % this.slideTargets.length)
  }

  next () {
    this.advance()
  }

  goTo (event) {
    const index = typeof event === 'number' ? event : Number(event.currentTarget.dataset.promotedCarouselIndex)
    if (Number.isNaN(index)) return

    this.index = index
    this.showSlide(this.index)
    this.restartTimer()
  }

  advance () {
    this.index = (this.index + 1) % this.slideTargets.length
    this.showSlide(this.index)
  }

  showSlide (index) {
    this.slideTargets.forEach((el, i) => {
      const active = i === index
      el.classList.toggle('opacity-100', active)
      el.classList.toggle('z-10', active)
      el.classList.toggle('opacity-0', !active)
      el.classList.toggle('pointer-events-none', !active)
      el.classList.toggle('z-0', !active)
    })

    if (this.hasDotTarget) {
      this.dotTargets.forEach((dot, i) => {
        const active = i === index
        dot.classList.toggle('bg-slate-900', active)
        dot.classList.toggle('w-5', active)
        dot.classList.toggle('bg-slate-300', !active)
        dot.classList.toggle('w-1.5', !active)
        dot.setAttribute('aria-current', active ? 'true' : 'false')
      })
    }
  }

  restartTimer () {
    if (this.slideTargets.length < 2) return
    this.stopTimer()
    this.timer = window.setInterval(() => this.advance(), this.intervalValue)
  }

  stopTimer () {
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
  }
}
